import { Flex, Heading, VStack } from "@chakra-ui/react";
import { ProjectCard } from "./ProjectCard";
import GitHubCalendar from "react-github-calendar";
import "./project.css"


const data = [
  {
    title: "RECRUITEE.COM",
    desc: "Recruitee is a business producing or selling computer software as a service (Saas.) The software functions as an applicant tracking system for handling applications for jobs.",
    techStack:
      "HTML | CSS | JavaScrips",
    feature:
      "Navbar, Admin Panel, Shoting,Login, SingnUp etc ",
    img: "recruitee.png",
    clone: "https://github.com/sumitraghavwork/bashful-form-6526.git",
    deploy: "https://inquisitive-kashata-a201b3.netlify.app/index.html",
  },
  
  {
    title: "DERMSTORE.COM",
    desc: "Founded by a board-certified dermatologist, where customers could purchase with confidence. They have wide range of skin care and cosmetic brands.",
    techStack: "HTML | CSS | JavaScript | Browser Local Storage",
    feature:
      "Navbar, Footer, Product Page, CheckOut page, Payment Page, Shorting etc",
    img: "DERMSTORE.png",
    clone: "https://github.com/spidey52/dermstore-clone",
    deploy: "https://dermstore-web18.netlify.app/",
  },
  {
    title: "BEWAKOOF.COM",
    desc: "Bewakoof.com is an Indian E-Commerce Website that provide us trending fashion clothes store, that sells all types of clothes for mens and womems",
    techStack: "HTML | CSS | JavaScript | Browser Local Storage",
    feature:
      "Navbar, Footer, Product Page, CheckOut page, Payment Page, Shorting etc  ",
    img: "bewakoof.png",
    clone: "https://github.com/yogeshsaini21/bewakoof.com.git",
    deploy: "https://illustrious-rolypoly-40af8b.netlify.app/",
  },
  {
    title: "RODAN+FIELD.COM",
    desc: "This is a robust. It is a collaborative project where we try to implement our best possible knowledge to showcase and try to grab attention of users where they are looking for dermatological products",
    techStack: "ReactJs | Chakra UI | MongoDB | ExpressJs | ",
    feature:
      "Navbar, Login, SingnUp, Product Page, CheckOut page, Admin Panel etc ",
    img: "RodanField.png",
    clone: "https://github.com/Shubh596/Rodan-field-Clone.git",
    deploy: "https://stirring-cajeta-865e1e.netlify.app/",
  },
  {
    title: "YOOX.COM",
    desc: "This is an E-Commerce website of an Italian online fashion retailer created on 5 October 2015 after the merger between Yoox Group and Net-a-porter Group.",
    techStack: "ReactJs | Chakra UI | MongoDB | ExpressJs | CSS ",
    feature:
      "Navbar, Login, SingnUp, Product Page, CheckOut page, Admin Panel etc ",
    img: "Yoox.png",
    clone: "https://github.com/shubhojeet1/cut-price-5327.git",
    deploy: "https://smart-points.netlify.app/",
  },
];


export function Project() {
  return (
    <div  id="projects">
      <Heading mb="50px">My Projects</Heading>
   <div className="projectCar">
   {data.map((el, i) => {
        return <ProjectCard  class="project-card"  key={i} data={{ ...el }} />;
      })}
   </div>
      <VStack justifyContent={"center"} gap="30px">
        <br />

      {/* Github Start from here */}

        <Heading>GitHub Calender</Heading>
        <GitHubCalendar username="Shubh596" />
      </VStack>
      <br />
      <div style={{display: "flex", alignItems:"center", justifyContent:"center", gap:"60px"}}>
      <a href="http://www.github.com/Shubh596">
<img  id="github-stats-card" align="center" src="https://github-readme-stats.vercel.app/api?username=Shubh596&show_icons=true&hide=&count_private=true&title_color=00cccc&text_color=ffffff&icon_color=f97316&bg_color=404040&hide_border=true&show_icons=true"
    alt="Shubh596's GitHub stats"/></a>


<a href="http://www.github.com/Shubh596"><img align="center" id="github-streak-stats"
    src="https://github-readme-streak-stats.herokuapp.com/?user=Shubh596&stroke=ffffff&background=404040&ring=00cccc&fire=00cccc&currStreakNum=ffffff&currStreakLabel=00cccc&sideNums=ffffff&sideLabels=ffffff&dates=ffffff&hide_border=true"/></a>
      </div>
      <br />
      <div >
      <a href="http://www.github.com/Shubh596"><img style={{margin:"auto"}} align="center" id="github-top-langs"
    src="https://github-readme-stats.vercel.app/api/top-langs/?username=shubh596"/></a>
      </div>
    </div>
  );
}


